module.exports = __webpack_public_path__ + "img/img_brand6.3766b0d4.jpg";